import { useSelector } from 'react-redux'

import { selectTerritoryLicensingLimits } from '@/features/domain/territory'
import { useEffect, useState } from 'react'
import { useControllerActions } from './useControllerActions'

export function useControllerData() {
  const { planningRange } = useSelector(selectTerritoryLicensingLimits)
  const { onPlanningRangeChange } = useControllerActions()
  const [percentage, setPercentage] = useState<number>(0)

  useEffect(() => {
    const fetchPercentage = async () => {
      const result = await onPlanningRangeChange(planningRange)
      setPercentage(result?.percentage ?? 0)
    }
    fetchPercentage()
  }, [planningRange, onPlanningRangeChange])

  return {
    planningRange,
    percentage,
  }
}
